import { Button } from "@ui";
import style from "./ControlPanel.module.scss";
import { AbsoluteBlock } from "UI/shared";
import { ProxySettings } from "./components/ProxySettings/ProxySettings";
import { useParams } from "react-router-dom";
import { useGetAllUsersQuery } from "@RTKQuery/admin/customers/customers";

export function ControlPanel() {
    const { id } = useParams();

    const customerId = Number(id);
    const { currentData, isError, refetch } = useGetAllUsersQuery({
        limit: 1, page: 1, search: String(customerId), is_active: "all"
    }, { skip: !Number.isInteger(customerId) || customerId <= 0 });
    const data = currentData?.users.find(item => item.id === customerId);


    return (
        <div className={style.container}>
            <p className={style.userId}><span>Клієнт</span> id: {id}</p>
            <div className={style.box}>
                <p className={style.balance}> <span>Баланс:</span> {data ? `$${data.balance}` : "…"}</p>
                <AbsoluteBlock
                    XAlign="left"
                    advancedAdaptive
                    targetElement={
                        <Button
                            disabled={!data}
                            color="blue"
                            form="rectangle"
                            text="Редагувати"
                            customStyle={{
                                button: "!h-[42px] !px-[50px]",
                                text: "!text-[15px]"
                            }}
                        />
                    }
                    content={(isOpen) => <ProxySettings isOpen={isOpen} funds term grant userData={data} />}
                />
            </div>
            {isError && <p role="alert">Не вдалося завантажити клієнта. <button type="button" onClick={() => refetch()}>Спробувати ще раз</button></p>}
        </div>
    )
}

